import React, { useState, useEffect } from "react";
import { Link, withRouter } from "react-router-dom";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

// style
import Style from "./style";

// image
import Chevron from "../../Assets/down-chevron.svg";
import SvgIcon from "../../Assets/svg-icon.svg";
import PdfIcon from "../../Assets/pdf-icon.svg";
import Select from "react-select";
import { Switch, ConfigProvider, TimePicker, Space } from "antd";
import dayjs from "dayjs";
import TimeIcon from "../../Assets/Themes/Time.svg";
import QuestionDrag from "../../Assets/question-drag.svg";
import QuestionDel from "../../Assets/del-question.svg";

// -- redux
import { connect } from "react-redux";
import {
  AddService,
  DeleteService,
  ServiceDetails,
  QuestionDropdownList,
  EditService,
  ResetAddServiceData,
} from "../../Redux/Actions/ServicesAction";
import Loader from "../Loader";
import Modal from "../Modal";
import { Info } from "@mui/icons-material";
import { da } from "date-fns/locale";
import { icon } from "@fortawesome/fontawesome-svg-core";
import { set } from "date-fns";
import { on } from "rsuite/esm/DOMHelper";

const { RangePicker } = TimePicker;

function Services(props) {
  const [Title, setTitle] = useState("");
  const [TitleError, setTitleError] = useState("");
  // const [UserType, setUserType] = useState("");
  // const [OnFleetType, setOnFleetType] = useState("");
  const [QuestionType, setQuestionType] = useState("");
  const [QuestionTypeID, setQuestionTypeID] = useState("");
  const [OnFleetTypeID, setOnFleetTypeID] = useState("");
  const [AlreadyExists, setAlreadyExists] = useState("");
  const [UserTypeID, setUserTypeID] = useState("");
  const [Type, setType] = useState("");
  const [Information, setInformation] = useState("");
  const [InformationID, setInformationID] = useState("");
  const [InformationError, setInformationError] = useState("");
  const [AndroidUrl, setAndroidUrl] = useState("");
  const [IOSUrl, setIOSUrl] = useState("");
  const [AndroidInformationError, setAndroidInformationError] = useState("");
  const [IosInformationError, setIosInformationError] = useState("");
  const [TypeID, setTypeID] = useState("");
  const [emailNotification, setEmailNotification] = useState("");
  const [emailNotificationError, setEmailNotificationError] = useState("");
  const [OpenModal, setModal] = useState(false);
  const [ImgName, setImgName] = useState("");
  const [base64Icon, setBase64Icon] = useState("");
  const [TimePickerError, setTimePickerError] = useState(false);
  const [StartTime, setStartTime] = useState(null);
  const [EndTime, setEndTime] = useState(null);
  const [CardsArray, setCardsArray] = useState([]);
  const [SVGError, setSVGError] = useState("");
  const [PDFError, setPDFError] = useState("");
  const [businessIsInDB, setBusinessIsInDB] = useState(false);
  const [originalUserTypeIDs, setOriginalUserTypeIDs] = useState("");
  const [autoGeneratedService, setAutoGeneratedService] = useState(false);
  useEffect(() => {
    if (props.location.pathname.split("/")[3] === "edit-services") {
      props.ServiceDetails(props.location.state);
    }

    props.QuestionDropdownList();
  }, []);

  useEffect(() => {
    if (
      props.details_data &&
      props.details_data.data &&
      props.location.pathname.split("/")[3] === "edit-services"
    ) {
      let user = "";
      props.details_data.data.service_role.map((value) => {
        if (value.role_id == 2) {
          user += "2,";
        }
        if (value.role_id == 3) {
          user += "3,";
          setBusinessIsInDB(true);
        }
        if (value.role_id == 5) {
          user += "5,";
        }
      });
      setTitle(props.details_data.data && props.details_data.data.title);
      setAutoGeneratedService(
        props.details_data.data &&
          props.details_data.data.auto_generated_service
      );
      setBase64Icon(props.details_data.data.icon);
      if (user.endsWith(",")) {
        setOriginalUserTypeIDs(user.substring(0, user.length - 1));
        setUserTypeID(user.substring(0, user.length - 1));
      } else {
        setOriginalUserTypeIDs(user);
      }
      setTypeID(
        props.details_data.data && props.details_data.data.type.toString()
      );
      setOnFleetTypeID(
        props.details_data.data &&
          props.details_data.data.onfleet_type.toString()
      );
      props.details_data.data.start_time === ""
        ? setStartTime()
        : setStartTime(dayjs(props.details_data.data.start_time, "HH:mm"));
      props.details_data.data.end_time === ""
        ? setEndTime()
        : setEndTime(dayjs(props.details_data.data.end_time, "HH:mm"));
      setCardsArray(
        props.details_data.data && props.details_data.data.questions
      );
      setInformationID(
        props.details_data.data && props.details_data.data.information
      );
      setInformation(
        props.details_data.data && props.details_data.data.information
      );
      if (props.details_data.data.notification_email)
        setEmailNotification(props.details_data.data.notification_email);
      else setEmailNotification("");
      props.details_data.data.app_android_url === null
        ? setAndroidUrl("")
        : setAndroidUrl(
            props.details_data.data.app_android_url &&
              props.details_data.data.app_android_url
          );
      props.details_data.data.app_ios_url === null
        ? setIOSUrl("")
        : setIOSUrl(
            props.details_data.data.app_ios_url &&
              props.details_data.data.app_ios_url
          );
    }
  }, [props.details_data]);

  useEffect(() => {
    if (props.add_data && props.add_data.status == 200) {
      props.history.push({
        pathname: "/dashboard/services",
        back: "yes",
        method: "add",
      });
    }
  }, [props.add_data]);

  const renderList = () => {
    if (props.question_data && props.question_data.data) {
      console.log(JSON.stringify(props));
      return props.question_data.data.map((data) => ({
        label: data.title,
        value: data.title,
        id: data.id,
      }));
    }
  };

  const convertSvgToBase64 = (file) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64String = e.target.result;
      console.log(base64String);
      setBase64Icon(base64String);
    };
    reader.onerror = (error) => {
      console.error("Error reading file:", error);
    };
    reader.readAsDataURL(file);
  };

  const handleChange = (e, type) => {
    e.preventDefault();
    if (e.target.files[0].size / 1024 < 2000) {
      if (e.target.files[0].type === "image/svg+xml") {
        e.target.files[0] && setImgName(e.target.files[0].name);
        convertSvgToBase64(e.target.files[0]);
        console.log("DATA", base64Icon);
        setSVGError("");
      } else {
        setSVGError("Only svg is allowed");
      }
    } else {
      setSVGError("File size exceeds");
    }
  };

  const colourStyles = {
    control: (styles, state) => ({
      ...styles,
      backgroundColor: "#3C3C3C",
      border: state.isFocused ? "1px solid #A0A0A0" : "1px solid #3C3C3C",
      transition: "all 0.25s linear 0s",
      "&:hover": {
        border: "1px solid #A0A0A0",
      },
      padding: "4px 6px",
      boxShadow: state.isFocused ? null : null,
    }),
    singleValue: (baseStyles, state) => ({
      ...baseStyles,
      color: state.isFocused ? "#ffffff" : "#ffffff",
      backgroundColor: "#3C3C3C",
    }),
  };

  function toArray(obj) {
    if (obj == null) {
      return [];
    } else if (Array.isArray(obj)) {
      return obj;
    } else {
      return [obj];
    }
  }

  function iif(condition, trueObj, falseObj) {
    return condition ? toArray(trueObj) : toArray(falseObj);
  }

  const UserTypeOptions = [
    { value: "Personal Banking", label: "Personal Banking", id: "2" },
    { value: "Business", label: "Business", id: "3" },
    ...iif(sessionStorage.getItem("selectedBank") === "1", {
      value: "V1be User",
      label: "V1be User",
      id: "5",
    }),
  ];

  const TypeOptions = [
    { value: "Tab", label: "Tab", id: "1" },
    { value: "App", label: "App", id: "2" },
    { value: "WebView", label: "WebView", id: "4" },
    { value: "Form", label: "Form", id: "5" },
  ];

  const OnFleetTypeOptions = [
    { value: "None", label: "None", id: "0" },
    { value: "Delivery", label: "Delivery", id: "1" },
    { value: "Pickup", label: "Pickup", id: "2" },
  ];

  const KeyTabOptions = [
    { value: "Home", label: "Home", id: "1" },
    { value: "Products", label: "Products", id: "2" },
    { value: "Services", label: "Services", id: "3" },
    { value: "Social", label: "Social", id: "4" },
    { value: "Help", label: "Help", id: "5" },
  ];

  const ServiceInformationOptions = [
    { value: "Change Name", label: "Change Name", id: "11" },
  ];

  const selectUserType = (selected) => {
    const selectedUserTypes = selected.selected.map((item) =>
      parseInt(item.id)
    );
    setUserTypeID(selectedUserTypes.join(","));
  };

  const selectType = (selected) => {
    setType(selected.label);
    setTypeID(selected.id);
    setInformationError("");
    setInformation("");
    setInformationID("");
    setQuestionTypeID("");
    setAndroidUrl("");
    setIOSUrl("");
    setIosInformationError("");
    setAndroidInformationError("");
    setEmailNotification("");
  };

  const selectOnFleetType = (selected) => {
    // setOnFleetType(selected.label);
    setOnFleetTypeID(selected.id);
  };

  const selectQuestionType = (selected) => {
    setQuestionType(selected.label);
    setQuestionTypeID(selected.id);
  };

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(CardsArray);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setCardsArray(items);
    passData(items);
  };

  const passData = (items) => {
    let data = [];
    items.map((arr) => {
      let index = items.findIndex((x) => x.id === arr.id);
      let id = items.filter((x) => x.question_id === arr.question_id);
      data.push({
        id: id[0].id,
        order_number: index + 1,
        question_id: id[0].question_id,
        title: id[0].title,
        is_mandatory: id[0].is_mandatory,
        is_deleted: id[0].is_deleted,
      });
    });
    console.log("DATA", data);
    setCardsArray(data);
  };

  const HandleStatus = (id) => {
    const InitialArray = [...CardsArray];
    const targetIndex = CardsArray.findIndex((f) => f.question_id === id);
    InitialArray[targetIndex].is_mandatory =
      InitialArray[targetIndex].is_mandatory === 1 ? 0 : 1;
    setCardsArray(InitialArray);
  };

  const handleAdd = () => {
    if (QuestionTypeID === "") {
      setAlreadyExists("Please select question first.");
    } else {
      const FilteredArray = CardsArray.filter((question) => {
        const postName = question.question_id;
        return postName === QuestionTypeID;
      });
      const deletedArray = CardsArray.filter((question) => {
        return (
          QuestionTypeID === question.question_id && question.is_deleted === 1
        );
      });
      if (deletedArray.length > 0) {
        const InitialArray = [...CardsArray];
        const targetIndex = deletedArray.filter(
          (f) => f.question_id === QuestionTypeID
        );
        if (targetIndex[0].is_deleted === 1) {
          targetIndex[0].is_deleted = 0;
        } else {
          targetIndex[0].is_deleted = 1;
        }
        setCardsArray(InitialArray);
      } else {
        if (FilteredArray.length > 0) {
          setAlreadyExists(
            "Question already added. Please select another question."
          );
        } else {
          setAlreadyExists("");
          const InitialArray = [...CardsArray];
          InitialArray.push({
            title: QuestionType,
            is_mandatory: 1,
            question_id: QuestionTypeID,
            order_number: CardsArray.slice(-1)[0]
              ? CardsArray.slice(-1)[0].order_number + 1
              : CardsArray.length + 1,
            id: 0,
          });
          setCardsArray(InitialArray);
        }
      }
      setQuestionTypeID("");
    }
  };

  const handleDelete = (question) => {
    if (autoGeneratedService) {
      return;
    } else {
      setAlreadyExists("");
      if (question.id === 0) {
        const InitialArray = [...CardsArray];
        let index = CardsArray.findIndex(function (o) {
          return o.question_id === question.question_id;
        });
        if (index !== -1) InitialArray.splice(index, 1);
        setCardsArray(InitialArray);
      } else {
        const InitialArray = [...CardsArray];
        question.is_deleted = 1;
        let index = InitialArray.findIndex(function (o) {
          return o.id === question.id;
        });
        if (index !== -1) CardsArray.splice(index, 1);
        setCardsArray(InitialArray);
      }
    }
  };

  const handleModal = (e, type) => {
    if (type === "update") {
      // Get the IDs of options before the change
      const original = originalUserTypeIDs.split(",").map((id) => parseInt(id));
      // Get the IDs of options after the change
      const currentUserTypeIDs = UserTypeID.split(",").map((id) =>
        parseInt(id)
      );
      if (original.includes(3) && !currentUserTypeIDs.includes(3)) {
        setModal("remove_business");
      } else {
        if (emailNotification.length > 0) {
          let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
          if (!emailRegex.test(emailNotification)) {
            setEmailNotificationError("Invalid email");
            alert("Invalid Notification EMail Address");
            return;
          }
        }

        if (Title.length < 3) {
          if (Title.length < 3) {
            setTitleError("Minimum 3 characters");
            setTimeout(() => {
              setTitleError("");
            }, 10000);
          }
        } else {
          let expression =
            /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;
          let regex = new RegExp(expression);
          let expressionHttps = /^https:\/\//;
          let regexHttps = new RegExp(expressionHttps);
          if (TypeID === "4") {
            if (Information.match(regex)) {
              setInformationError("");
              setModal(type);
            } else {
              setInformationError("Invalid URL");
            }
          } else if (TypeID === "2") {
            if (
              AndroidUrl.match(regex) &&
              AndroidUrl.match(regexHttps) &&
              IOSUrl.match(regex) &&
              IOSUrl.match(regexHttps)
            ) {
              setAndroidInformationError("");
              setIosInformationError("");
              setModal(type);
            } else {
              if (AndroidUrl.match(regex) && AndroidUrl.match(regexHttps)) {
                setAndroidInformationError("");
              }
              if (IOSUrl.match(regex) && IOSUrl.match(regexHttps)) {
                setIosInformationError("");
              }
              if (
                AndroidUrl.match(regex) === null ||
                AndroidUrl.match(regexHttps) === null
              ) {
                setAndroidInformationError("Invalid URL");
              }
              if (
                IOSUrl.match(regex) === null ||
                IOSUrl.match(regexHttps) === null
              ) {
                setIosInformationError("Invalid URL");
              }
            }
          } else {
            setModal(type);
          }
        }
      }
    } else {
      setModal(type);
    }
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "add_yes") {
      if (TypeID !== "5") {
        if (TypeID === "2") {
          const data = {
            title: Title,
            notification_email: emailNotification,
            user_type: UserTypeID,
            information: "",
            app_android_url: AndroidUrl,
            app_ios_url: IOSUrl,
            type: TypeID,
            module_type:
              props.location.pathname.split("/")[2] === "services" ? 0 : 1,
          };
          props.AddService(data);
          setModal(false);
          if (props.location.pathname.split("/")[2] === "services") {
            // props.history.push({
            //     pathname: '/dashboard/services',
            //     back: 'yes',
            //     method: 'add'
            // })
          } else {
            props.history.push({
              pathname: "/dashboard/settings",
              back: "yes",
              method: "add",
            });
          }
        } else {
          const data = {
            title: Title,
            icon: base64Icon,
            notification_email: emailNotification,
            user_type: UserTypeID,
            information: InformationID || Information,
            type: TypeID,
            module_type:
              props.location.pathname.split("/")[2] === "services" ? 0 : 1,
          };
          props.AddService(data);
          setModal(false);
          if (props.location.pathname.split("/")[2] === "services") {
            // props.history.push({
            //     pathname: '/dashboard/services',
            //     back: 'yes',
            //     method: 'add'
            // })
          } else {
            props.history.push({
              pathname: "/dashboard/settings",
              back: "yes",
              method: "add",
            });
          }
        }
      } else {
        let Questions = [];
        CardsArray.map((array) => {
          Questions.push({
            id: array.question_id === undefined ? 0 : array.id,
            question_id:
              array.question_id === undefined
                ? QuestionTypeID
                : array.question_id,
            order_number: array.order_number,
            is_mandatory: array.is_mandatory,
            is_deleted: array.is_deleted === undefined ? 0 : array.is_deleted,
          });
        });
        const data = {
          title: Title,
          icon: base64Icon,
          notification_email: emailNotification,
          user_type: UserTypeID,
          type: TypeID,
          start_time: OnFleetTypeID === "0" ? "" : StartTime,
          end_time: OnFleetTypeID === "0" ? "" : EndTime,
          onfleet_type: OnFleetTypeID,
          question: Questions,
          information: "",
          module_type:
            props.location.pathname.split("/")[2] === "services" ? 0 : 1,
          question: Questions,
        };
        props.AddService(data);
        if (props.location.pathname.split("/")[2] === "services") {
          // props.history.push({
          //     pathname: '/dashboard/services',
          //     back: 'yes',
          //     method: 'add'
          // })
        } else {
          props.history.push({
            pathname: "/dashboard/settings",
            back: "yes",
            method: "add",
          });
        }
      }
    } else if (type === "add_no") {
      setModal(false);
    } else if (type === "update_yes") {
      if (TypeID !== "5") {
        if (TypeID === "2") {
          const data = {
            id: props.location.state,
            title: Title,
            icon: base64Icon,
            notification_email: emailNotification,
            user_type: UserTypeID,
            information: "",
            app_android_url: AndroidUrl,
            app_ios_url: IOSUrl,
            type: TypeID,
            module_type:
              props.location.pathname.split("/")[2] === "services" ? 0 : 1,
          };
          props.EditService(data);
          setModal(false);
          if (props.location.pathname.split("/")[2] === "services") {
            props.history.push({
              pathname: "/dashboard/services",
              back: "yes",
              method: "update",
            });
          } else {
            props.history.push({
              pathname: "/dashboard/settings",
              back: "yes",
              method: "update",
            });
          }
        } else {
          const data = {
            id: props.location.state,
            title: Title,
            icon: base64Icon,
            notification_email: emailNotification,
            user_type: UserTypeID,
            information: Information,
            type: TypeID,
            module_type:
              props.location.pathname.split("/")[2] === "services" ? 0 : 1,
          };
          props.EditService(data);
          setModal(false);
          if (props.location.pathname.split("/")[2] === "services") {
            props.history.push({
              pathname: "/dashboard/services",
              back: "yes",
              method: "update",
            });
          } else {
            props.history.push({
              pathname: "/dashboard/settings",
              back: "yes",
              method: "update",
            });
          }
        }
      } else {
        let Questions = [];
        CardsArray.map((array) => {
          Questions.push({
            id: array.question_id === undefined ? 0 : array.id,
            question_id:
              array.question_id === undefined
                ? QuestionTypeID
                : array.question_id,
            order_number: array.order_number,
            is_mandatory: array.is_mandatory,
            is_deleted: array.is_deleted === undefined ? 0 : array.is_deleted,
          });
        });
        const data = {
          id: props.location.state,
          title: Title,
          icon: base64Icon,
          notification_email: emailNotification,
          user_type: UserTypeID,
          type: TypeID,
          start_time: OnFleetTypeID === "0" ? "" : StartTime,
          end_time: OnFleetTypeID === "0" ? "" : EndTime,
          onfleet_type: OnFleetTypeID,
          question: autoGeneratedService ? null : Questions,
          information: Information === null ? "" : Information,
          module_type:
            props.location.pathname.split("/")[2] === "services" ? 0 : 1,
        };
        props.EditService(data);
        setModal(false);
        if (props.location.pathname.split("/")[2] === "services") {
          props.history.push({
            pathname: "/dashboard/services",
            back: "yes",
            method: "update",
          });
        } else {
          props.history.push({
            pathname: "/dashboard/settings",
            back: "yes",
            method: "update",
          });
        }
      }
    } else if (type === "update_no") {
      setModal(false);
    } else if (type === "remove_business_user_type") {
      const originalUserTypeIDs = UserTypeID.split(",").map((id) =>
        parseInt(id)
      );
      const updatedUserTypeIDs = originalUserTypeIDs.filter((id) => id !== 3);
      setOriginalUserTypeIDs(updatedUserTypeIDs);
      setUserTypeID(updatedUserTypeIDs.join(","));
      setModal(false);
      setModal("update");
    } else if (type === "dont_remove_business_user_type") {
      const userTypeIdArray = UserTypeID.split(",").map((id) => parseInt(id));
      userTypeIdArray.push(3);
      setUserTypeID(userTypeIdArray.join(","));
      setModal(false);
    } else if (type === "delete_yes") {
      props.DeleteService(props.location.state);
      if (props.location.pathname.split("/")[2] === "services") {
        props.history.push({
          pathname: "/dashboard/services",
          back: "yes",
          method: "delete",
        });
      } else {
        props.history.push({
          pathname: "/dashboard/settings",
          back: "yes",
          method: "delete",
        });
      }
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  const handleTypeChange = (selected) => {
    setInformation(selected);
    setInformationID(selected.id);
  };

  const handleCancel = () => {
    if (props.location.pathname.split("/")[2] === "services") {
      props.history.push({
        pathname: "/dashboard/services",
        back: "yes",
      });
    } else {
      props.history.push({
        pathname: "/dashboard/settings",
        back: "yes",
      });
    }
  };

  const handleTitle = (e) => {
    if (e.target.value.length < 71) {
      setTitle(e.target.value);
      setTitleError("");
    } else {
      setTitleError("Max 70 characters");
    }
  };

  const handleEMail = (e) => {
    if (e.target.value.length < 255) {
      setEmailNotification(e.target.value);
      setEmailNotificationError("");
    } else {
      // setHeaderTitleError("Max 255 characters");
    }
  };

  const checkEMail = (e) => {
    if (emailNotification.length > 0) {
      let emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,})+$/;
      if (emailRegex.test(emailNotification)) {
        setEmailNotification(e.target.value);
        setEmailNotificationError("");
      } else {
        setEmailNotificationError("Invalid email");
      }
    }
  };

  const onCalendarStartChange = (value) => {
    if (value === null) {
      // clear button selected
      setStartTime(null);
      console.log("Cleared");
      return;
    }
    setStartTime(dayjs(value));
  };

  const onCalendarEndChange = (value) => {
    if (value === null) {
      // clear button selected
      setEndTime(null);
      console.log("Cleared");
      return;
    }
    setEndTime(dayjs(value));
  };

  return (
    <>
      {props.loading && <Loader />}
      <div className="action-wrap">
        <div className="d-flex justify-content-between align-items-center head-wrap mb-4">
          {props.location.pathname.split("/")[2] === "services" ? (
            <Link to="/dashboard/services" className="d-flex head-left">
              <img src={Chevron} alt="Chevron" />
              <span className="text-nowrap text-white f-20 pl-3 text-uppercase">
                {props.location.pathname.split("/")[3] === "edit-services"
                  ? "Edit"
                  : "Add"}{" "}
                {props.location.pathname.split("/")[2] === "services"
                  ? "Service"
                  : "Setting"}
              </span>
            </Link>
          ) : (
            <Link to="/dashboard/settings" className="d-flex head-left">
              <img src={Chevron} alt="Chevron" />
              <span className="text-nowrap text-white f-20 pl-3 text-uppercase">
                {props.location.pathname.split("/")[3] === "edit-services"
                  ? "Edit"
                  : "Add"}{" "}
                {props.location.pathname.split("/")[2] === "services"
                  ? "Service"
                  : "Setting"}
              </span>
            </Link>
          )}
        </div>
        <div className="d-flex justify-content-between flex-wrap">
          <div className="w-50 pr-4">
            <label className="text-grey-6 f-16 d-block mb-1">
              Icon<span className="text-danger">*</span>
            </label>
            <div className="d-flex justify-content-between flex-wrap">
              <div className="text-center w-50 pr-4">
                <label className="custom-file-upload w-100 position-relative d-flex align-items-center justify-content-center mb-0">
                  <input
                    className="d-none"
                    type="file"
                    accept="image/svg+xml"
                    onClick={(e) => (e.target.value = null)}
                    onChange={(e) => handleChange(e, "svg-theme-icon")}
                  />
                  <div className="w-100">
                    {base64Icon !== "" ? (
                      <img
                        src={base64Icon}
                        alt="svg-icon"
                        style={{
                          width: "30%",
                          height: "30%",
                          objectFit: "contain",
                        }}
                      />
                    ) : (
                      <span>Click to browse</span>
                    )}
                    {base64Icon !== "" && (
                      <p className="text-white mb-0 mt-1 col-12 ml-auto mr-auto text-truncate">
                        {ImgName}
                      </p>
                    )}
                    {base64Icon !== "" && (
                      <div
                        onClick={(e) => {
                          e.preventDefault();
                          e.stopPropagation();
                          setBase64Icon("");
                        }}
                        className="remove-button"
                      >
                        <p className="text-uppercase mb-0 text-white">Remove</p>
                      </div>
                    )}
                  </div>
                </label>
                {SVGError && (
                  <p className="text-danger f-12 m-0 text-left">{SVGError}</p>
                )}
                <span style={{ color: "#A0A0A0" }} className="f-12">
                  Upload SVG
                </span>
              </div>
            </div>
          </div>
          <div className="w-50 pl-4">
            <div>
              <label className="text-grey-6 f-16 d-block mb-1">
                Title<span className="text-danger">*</span>
              </label>
              <input
                type="text"
                value={Title}
                onChange={(e) => handleTitle(e)}
                placeholder="Enter Title"
                className="w-100"
              />
              {TitleError && (
                <p className="ml-2 f-12 text-danger">{TitleError}</p>
              )}
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-between mt-4">
          <div className="mr-4 w-50">
            <label className="text-grey-6 f-16 d-block mb-1">
              User type<span className="text-danger">*</span>
            </label>
            <Select
              onChange={(selected) => selectUserType({ selected })}
              options={UserTypeOptions}
              styles={colourStyles}
              isMulti={true}
              placeholder="Select Type"
              value={
                UserTypeOptions.filter(function (option) {
                  return UserTypeID.indexOf(option.id) !== -1
                    ? option.id
                    : UserTypeID == 1
                    ? option
                    : "";
                }) || ""
              }
            />
          </div>
        </div>
        <div className="d-flex justify-content-between mt-4">
          {!autoGeneratedService && (
            <div className="mr-4 w-50">
              <label className="text-grey-6 f-16 d-block mb-1">
                Type<span className="text-danger">*</span>
              </label>
              <Select
                onChange={(selected) => selectType(selected)}
                options={TypeOptions}
                styles={colourStyles}
                placeholder="Select Type"
                isDisabled={autoGeneratedService === 1}
                value={TypeOptions.filter(function (option) {
                  return option.id === TypeID;
                })}
              />
            </div>
          )}
          {TypeID === "5" && (
            <div className={autoGeneratedService ? "w-50" : "ml-4 w-50"}>
              <label className="text-grey-6 f-16 d-block mb-1">
                Service Notification Email
              </label>
              <input
                type="text"
                value={emailNotification}
                onChange={(e) => handleEMail(e)}
                onBlur={(e) => checkEMail(e)}
                placeholder="Service Notification Email"
                className="w-100"
              />
              {emailNotificationError && (
                <p className="ml-2 f-12 text-danger">
                  {emailNotificationError}
                </p>
              )}
            </div>
          )}
        </div>
        <div className="d-flex justify-content-between mt-4">
          {TypeID === "1" && (
            <div className="w-50 pr-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Key<span className="text-danger">*</span>
              </label>
              <Select
                value={
                  KeyTabOptions.filter(function (option) {
                    return option.id === InformationID;
                  }) || ""
                }
                onChange={(e) => handleTypeChange(e)}
                options={KeyTabOptions}
                styles={colourStyles}
                placeholder="Choose Type"
              />
            </div>
          )}
          {TypeID === "2" && (
            <>
              <div className="pr-4 w-50 mt-4">
                <label className="text-grey-6 f-16 d-block mb-1">
                  IOS url<span className="text-danger">*</span>
                </label>
                <input
                  value={IOSUrl}
                  onChange={(e) => setIOSUrl(e.target.value)}
                  type="text"
                  placeholder="Enter url"
                  className="w-100 input-style"
                  id="Key"
                />
                {IosInformationError && (
                  <p className="f-12 text-danger mb-0">{IosInformationError}</p>
                )}
              </div>
              <div className="pr-4 w-50 mt-4">
                <label className="text-grey-6 f-16 d-block mb-1">
                  Android url<span className="text-danger">*</span>
                </label>
                <input
                  value={AndroidUrl}
                  onChange={(e) => setAndroidUrl(e.target.value)}
                  type="text"
                  placeholder="Enter url"
                  className="w-100 input-style"
                  id="Key"
                />
                {AndroidInformationError && (
                  <p className="f-12 text-danger mb-0">
                    {AndroidInformationError}
                  </p>
                )}
              </div>
            </>
          )}
          {TypeID === "3" && (
            <div className="w-50 pr-4">
              <label className="text-grey-6 f-16 d-block mb-1">
                Key<span className="text-danger">*</span>
              </label>
              <Select
                value={
                  ServiceInformationOptions.filter(function (option) {
                    return option.id === InformationID;
                  }) || ""
                }
                onChange={(e) => handleTypeChange(e)}
                options={ServiceInformationOptions}
                styles={colourStyles}
                placeholder="Choose Type"
              />
            </div>
          )}
          {TypeID === "4" && (
            <div className="w-50 pr-4">
              <label htmlFor="Key" className="text-grey-6 f-16 d-block mb-1">
                Key <span className="text-danger">*</span>
              </label>
              <input
                value={Information}
                onChange={(e) => setInformation(e.target.value)}
                type="text"
                placeholder="Enter url"
                className="w-100 input-style"
                id="Key"
              />
              {InformationError && (
                <p className="f-12 text-danger">{InformationError}</p>
              )}
            </div>
          )}
        </div>
        {TypeID === "5" && (
          <div>
            {!autoGeneratedService && (
              <div className="d-flex justify-content-between mt-4">
                <div className="pr-4 w-50">
                  <label className="text-grey-6 f-16 d-block mb-1">
                    Onfleet Type<span className="text-danger">*</span>
                  </label>
                  <Select
                    onChange={(selected) => selectOnFleetType(selected)}
                    options={OnFleetTypeOptions}
                    styles={colourStyles}
                    placeholder="Select Type"
                    isDisabled={autoGeneratedService}
                    value={OnFleetTypeOptions.filter(function (option) {
                      return option.id === OnFleetTypeID;
                    })}
                  />
                </div>
                {OnFleetTypeID !== "0" && (
                  <div className="pl-4 w-50">
                    <div className="d-flex justify-content-between">
                      <div className="mr-4 w-50 Time-wrapper position-relative">
                        <label className="text-grey-6 f-16 d-block mb-1">
                          Start Time<span className="text-danger">*</span>
                        </label>
                        <ConfigProvider
                          theme={{
                            components: {
                              DatePicker: {
                                activeBorderColor: "#BDFF00",
                              },
                            },
                            token: {
                              colorBgContainer: "#646464",
                              colorTextPlaceholder: "#FFFFFF",
                              colorIcon: "#FFFFFF",
                              colorTextLightSolid: "#FFFFFF",
                              colorTextDisabled: "#FFFFFF",
                              colorTextDescription: "#FFFFFF",
                            },
                          }}
                        >
                          <Space>
                            <TimePicker
                              status={
                                TimePickerError === true ? "error" : "success"
                              }
                              variant={"Filled"}
                              value={StartTime}
                              format={"hh:mm A"}
                              use12Hours={true}
                              showNow={false}
                              onClear
                              onCalendarChange={onCalendarStartChange}
                              style={{
                                border: "1px solid #FFFFFF",
                              }}
                            />
                          </Space>
                        </ConfigProvider>
                      </div>
                      <div className="ml-4 w-50 Time-wrapper position-relative">
                        <label className="text-grey-6 f-16 d-block mb-1">
                          End Time<span className="text-danger">*</span>
                        </label>
                        <ConfigProvider
                          theme={{
                            components: {
                              DatePicker: {
                                activeBorderColor: "#BDFF00",
                              },
                            },
                            token: {
                              colorBgContainer: "#646464",
                              colorTextPlaceholder: "#FFFFFF",
                              colorIcon: "#FFFFFF",
                              colorTextLightSolid: "#FFFFFF",
                              colorTextDisabled: "#FFFFFF",
                              colorTextDescription: "#FFFFFF",
                            },
                          }}
                        >
                          <Space>
                            <TimePicker
                              status={
                                TimePickerError === true ? "error" : "success"
                              }
                              variant={"Filled"}
                              value={EndTime}
                              format={"hh:mm A"}
                              use12Hours={true}
                              showNow={false}
                              onClear
                              onCalendarChange={onCalendarEndChange}
                              style={{
                                border: "1px solid #FFFFFF",
                              }}
                            />
                          </Space>
                        </ConfigProvider>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
            {!autoGeneratedService && (
              <div className="mt-4">
                <label className="text-grey-6 f-16 d-block mb-1">
                  Search Question<span className="text-danger">*</span>
                </label>
                <div className="d-flex align-items-center">
                  <Select
                    onChange={(selected) => {
                      setAlreadyExists("");
                      selectQuestionType(selected);
                    }}
                    options={renderList()}
                    styles={colourStyles}
                    placeholder="Search Question"
                    isDisabled={autoGeneratedService}
                    value={
                      (renderList() &&
                        renderList().filter(function (option) {
                          return option.id === QuestionTypeID;
                        })) ||
                      ""
                    }
                    className="w-100"
                  />
                  <p
                    onClick={() => handleAdd()}
                    className="text-green f-30 cursor-pointer font-weight-bold pl-4 m-0"
                  >
                    +
                  </p>
                </div>
                {AlreadyExists && (
                  <p className="text-danger f-12">{AlreadyExists}</p>
                )}
              </div>
            )}
            <div className="mt-4">
              <label className="text-grey-6 f-16 d-block">
                Question -{" "}
                {CardsArray.length -
                  CardsArray.filter(function (item) {
                    return item.is_deleted === 1;
                  }).length}
              </label>
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable
                  droppableId="home_listing"
                  type="listing"
                  isDropDisabled={autoGeneratedService}
                >
                  {(provided) => (
                    <div {...provided.droppableProps} ref={provided.innerRef}>
                      {CardsArray.length > 0 &&
                        CardsArray.map((question, index) => {
                          return (
                            question.is_deleted !== 1 && (
                              <Draggable
                                key={index + 1}
                                draggableId={(index + 1).toString()}
                                index={index}
                              >
                                {(provided) => (
                                  <div
                                    className="mt-2"
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    key={index}
                                  >
                                    <div className="d-flex align-items-center">
                                      <div
                                        className="d-flex align-items-center p-3 w-100"
                                        style={{ background: "#3C3C3C" }}
                                      >
                                        <img
                                          src={QuestionDrag}
                                          alt="QuestionDrag"
                                        />
                                        <p className="text-white m-0 pl-4">
                                          {question.title}
                                        </p>
                                      </div>
                                      {!autoGeneratedService && (
                                        <img
                                          onClick={() => handleDelete(question)}
                                          src={QuestionDel}
                                          className="ml-4 cursor-pointer"
                                          alt="QuestionDrag"
                                        />
                                      )}
                                      {!autoGeneratedService && (
                                        <div className="ml-4">
                                          <p className="text-white label-para f-12 mb-0">
                                            Mandatory
                                          </p>
                                          <label className="switch mb-0">
                                            <input
                                              type="checkbox"
                                              disabled={autoGeneratedService}
                                              checked={
                                                question.is_mandatory === 1
                                              }
                                              readOnly
                                              onClick={() =>
                                                HandleStatus(
                                                  question.question_id
                                                )
                                              }
                                            />
                                            <span className="slider round" />
                                          </label>
                                        </div>
                                      )}
                                    </div>
                                  </div>
                                )}
                              </Draggable>
                            )
                          );
                        })}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-between mt-5">
          {props.location.pathname.split("/")[3] === "edit-services" && (
            <>
              {!autoGeneratedService && (
                <button
                  onClick={(e) => handleModal(e, "delete")}
                  className="form-button mr-3"
                >
                  Delete
                </button>
              )}
              {TypeID === "5" ? (
                <>
                  {OnFleetTypeID === "0" ? (
                    <button
                      disabled={
                        !(
                          (
                            OnFleetTypeID &&
                            TypeID &&
                            UserTypeID &&
                            Title &&
                            base64Icon
                          )
                          // &&
                          // (autoGeneratedService ? true : CardsArray.length)
                        )
                      }
                      onClick={(e) => handleModal(e, "update")}
                      className="form-button ml-3"
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      disabled={
                        !(
                          EndTime &&
                          StartTime &&
                          OnFleetTypeID &&
                          TypeID &&
                          UserTypeID &&
                          Title &&
                          base64Icon &&
                          CardsArray.length
                        )
                      }
                      onClick={(e) => handleModal(e, "update")}
                      className="form-button ml-3"
                    >
                      Update
                    </button>
                  )}
                </>
              ) : (
                <>
                  {TypeID === "2" ? (
                    <button
                      disabled={
                        !(
                          TypeID &&
                          UserTypeID &&
                          Title &&
                          base64Icon &&
                          AndroidUrl &&
                          IOSUrl
                        )
                      }
                      onClick={(e) => handleModal(e, "update")}
                      className="form-button ml-3"
                    >
                      Update
                    </button>
                  ) : (
                    <button
                      disabled={
                        !(
                          TypeID &&
                          UserTypeID &&
                          Title &&
                          base64Icon &&
                          (InformationID || Information)
                        )
                      }
                      onClick={(e) => handleModal(e, "update")}
                      className="form-button ml-3"
                    >
                      Update
                    </button>
                  )}
                </>
              )}
            </>
          )}
          {props.location.pathname.split("/")[3] === "add-services" && (
            <>
              {TypeID === "5" ? (
                <>
                  {OnFleetTypeID === "0" ? (
                    <>
                      <button
                        disabled={
                          !(
                            OnFleetTypeID ||
                            TypeID ||
                            UserTypeID ||
                            Title ||
                            base64Icon ||
                            CardsArray.length
                          )
                        }
                        onClick={(e) => handleCancel(e)}
                        className="form-button mr-3"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={
                          !(
                            OnFleetTypeID &&
                            TypeID &&
                            UserTypeID &&
                            Title &&
                            base64Icon &&
                            CardsArray.length
                          )
                        }
                        onClick={(e) => handleModal(e, "add")}
                        className="form-button ml-3"
                      >
                        Save
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        disabled={
                          !(
                            EndTime ||
                            StartTime ||
                            OnFleetTypeID ||
                            TypeID ||
                            UserTypeID ||
                            Title ||
                            base64Icon ||
                            CardsArray.length
                          )
                        }
                        onClick={(e) => handleCancel(e)}
                        className="form-button mr-3"
                      >
                        Cancel
                      </button>
                      <button
                        disabled={
                          !(
                            EndTime &&
                            StartTime &&
                            OnFleetTypeID &&
                            TypeID &&
                            UserTypeID &&
                            Title &&
                            base64Icon &&
                            CardsArray.length
                          )
                        }
                        onClick={(e) => handleModal(e, "add")}
                        className="form-button ml-3"
                      >
                        Save
                      </button>
                    </>
                  )}
                </>
              ) : (
                <>
                  <button
                    // disabled={
                    //   !(
                    //     TypeID ||
                    //     requestButtonTitle ||
                    //     UserTypeID ||
                    //     headerTitle ||
                    //     Title ||
                    //     ImgName ||
                    //     PdfName ||
                    //     (InformationID && Information)
                    //   )
                    // }
                    onClick={(e) => handleCancel(e)}
                    className="form-button mr-3"
                  >
                    Cancel
                  </button>
                  {TypeID === "2" ? (
                    <button
                      disabled={
                        !(
                          TypeID &&
                          UserTypeID &&
                          Title &&
                          base64Icon &&
                          AndroidUrl &&
                          IOSUrl
                        )
                      }
                      onClick={(e) => handleModal(e, "add")}
                      className="form-button ml-3"
                    >
                      Save
                    </button>
                  ) : (
                    <button
                      disabled={
                        !(
                          TypeID &&
                          UserTypeID &&
                          Title &&
                          base64Icon &&
                          (InformationID || Information)
                        )
                      }
                      onClick={(e) => handleModal(e, "add")}
                      className="form-button ml-3"
                    >
                      Save
                    </button>
                  )}
                </>
              )}
            </>
          )}
        </div>
        <Style />
        {OpenModal && (
          <Modal
            Name={Title}
            Type={OpenModal}
            Close={(e, type) => CloseModal(e, type)}
          />
        )}
      </div>
    </>
  );
}

const mapStateToProps = ({ ServicesReducer }) => {
  const { data, loading, details_data, question_data } = ServicesReducer;
  return { data, loading, details_data, question_data };
};

const mapDispatchToProps = {
  AddService,
  DeleteService,
  ServiceDetails,
  QuestionDropdownList,
  EditService,
  ResetAddServiceData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Services));
